import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { KeycloakService } from 'src/shared/services/keycloak.service';
import { LoaderService } from 'src/shared/services/loader.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
    protected authenticated: boolean = false;

    private subscription!: Subscription;

    constructor(
        private loader: LoaderService,
        private keycloakService: KeycloakService,
    ) {}

    public ngOnInit() {
        this.subscription = this.keycloakService.getKeycloakUser().subscribe({
            next: (user) => {
                this.authenticated = user.IstAuthentifiziert;
                console.log('Authenicated', this.authenticated);
                this.loader.hideLoader;
            },
            error: () => {
                this.loader.hideLoader();
            },
        });
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
